import state from '../initialState';

const initialState = {
  list: [],
  ...state,
};

export default initialState;
